import { CONFIRM_ACTION_REQUESTED, PROCEED_ACTION, CANCEL_ACTION } from './actionTypes';

const initialState = {
  isModalOpen: false,
  actionFunc: null,
  actionFuncArgs: [],
  content: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CONFIRM_ACTION_REQUESTED:
      return Object.assign({}, state, {
        isModalOpen: true,
        actionFunc: action.payload.actionFunc,
        actionFuncArgs: action.payload.actionFuncArgs,
        content: action.payload.content
      });
    case PROCEED_ACTION:
      return Object.assign({}, state, initialState);
    case CANCEL_ACTION:
      initialState.content = state.content;
      if(state.content) {
        setTimeout(() => {
          initialState.content = null;
          return Object.assign({}, state, initialState);
        }, 500);
      }
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/confirmAction/reducer.js